<script setup lang="ts">
import Notification from '@/components/notifications/Notification.vue';
import { computed, toRef, watchEffect } from 'vue';
import { useTranslation } from 'i18next-vue';
import { NotificationMessage } from '@/components/notifications/types';
import { useField } from 'vee-validate';

const { t } = useTranslation();

const { name } = defineProps<{
  name: string;
}>();

const { errorMessage, validate, meta } = useField(
  toRef(() => name),
  undefined,
  {
    validateOnMount: true,
    validateOnValueUpdate: true,
  },
);

watchEffect(() => {
  if (!meta.valid) {
    validate();
  }
});

const emits = defineEmits<{
  update: [];
}>();

const notification = computed<NotificationMessage | undefined>(() => {
  const updateRequired = !!errorMessage.value;

  return updateRequired
    ? {
        type: 'error',
        closable: false,
        title: t('SetupCombinationsParametersChangedTitle'),
        message: t('SetupCombinationsParametersChangedMessage'),
      }
    : undefined;
});
</script>

<template>
  <Notification v-if="notification" :value="notification" class="mt-5 mb-4 pa-4">
    <template #append>
      <PrimaryVBtn
        class="mt-3 d-block"
        :text="$t('SetupCombinationsParametersChangedNotification')"
        @click="emits('update')"
      />
    </template>
  </Notification>
</template>
